import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import '../SignUpPage/auth-pages.css';

import captCrest     from '../Assets/CAPT_crest.jpg';
import { FaLock } from 'react-icons/fa';

export default function ResetPasswordPage() {
    const navigate = useNavigate();
    const { username: usernameParam } = useParams();
    const handle = decodeURIComponent(usernameParam);  // original unchanged

    const [password, setPassword]           = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPw, setShowPw]               = useState(false);
    const [showConfirm, setShowConfirm]     = useState(false);
    const [errors, setErrors]               = useState({});
    const [loading, setLoading]             = useState(false);
    const [done, setDone]                   = useState(false);

    const clearError = (field) => setErrors(prev => ({ ...prev, [field]: '' }));

    // ── original logic, unchanged ──────────────────────────────────────────
    const handleChange = async () => {
        const e = {};
        if (!handle || !password || !confirmPassword) {
            e.submit = 'All fields are required.';
        } else if (password !== confirmPassword) {
            e.confirm = 'Passwords do not match.';
        }
        if (Object.keys(e).length) { setErrors(e); return; }

        setLoading(true);
        try {
            const response = await fetch(
                process.env.REACT_APP_BACKEND_URL + '/auth/reset-password/',
                {
                    method:  'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body:    JSON.stringify({ username: handle, new_password: password }),
                }
            );
            const data = await response.json();
            if (data.message) {
                setDone(true);
            } else {
                setErrors({ submit: data.error || 'Reset failed. Please try again.' });
            }
        } catch (error) {
            setErrors({ submit: 'Reset failed: ' + error.message });
        } finally {
            setLoading(false);
        }
    };
    // ──────────────────────────────────────────────────────────────────────

    return (
        <div className="ap-page">
            <div className="ap-wrap">

                {/* Brand */}
                <div className="ap-brand">
                    <div className="ap-brand-logo">
                        <div className="ap-logo-icon">
                            <img src={captCrest} alt="CAPT Crest" />
                        </div>
                        <span className="ap-wordmark">NEXUS</span>
                    </div>
                    <span className="ap-brand-sub">Captain Portal · By Tech Comm</span>
                </div>

                {/* Card */}
                <div className="ap-card">
                    <div className="ap-card-accent" />

                    {/* ── Success state ── */}
                    {done ? (
                        <>
                            <div className="ap-card-header">
                                <h1 className="ap-card-title">Password reset</h1>
                                <p className="ap-card-subtitle">Your account is secure again</p>
                            </div>
                            <div className="ap-card-body">
                                <div className="ap-success-state">
                                    <div className="ap-success-icon">
                                        <svg viewBox="0 0 28 28" fill="none" width="26" height="26">
                                            <path d="M5 14L11 20L23 8" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                    <h2 className="ap-success-title">All done!</h2>
                                    <p className="ap-success-desc">
                                        Password successfully reset for{' '}
                                        <strong>@{handle}</strong>. You can now sign in.
                                    </p>
                                    <button className="ap-btn-primary" onClick={() => navigate('/')}>
                                        <svg viewBox="0 0 16 16" fill="none" width="14" height="14">
                                            <path d="M6 3H3V13H6" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M10 5.5L13 8L10 10.5M13 8H6" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                        Sign in now
                                    </button>
                                </div>
                            </div>
                        </>
                    ) : (
                        /* ── Form state ── */
                        <>
                            <div className="ap-card-header">
                                <h1 className="ap-card-title">Reset Password</h1>
                                <p className="ap-card-subtitle">
                                    Choose a new password for{' '}
                                    <strong style={{ color: 'var(--ap-maroon)' }}>@{handle}</strong>
                                </p>
                            </div>

                            <div className="ap-card-body">

                                {/* New password */}
                                <div className="ap-field">
                                    <label className="ap-label" htmlFor="rp-password">New Password</label>
                                    <div className="ap-input-wrap">
                                        <FaLock className="ap-input-icon" style={{ width: 15, height: 15 }} />
                                        <input
                                            id="rp-password"
                                            className={`ap-input${errors.password ? ' ap-input--error' : ''}`}
                                            type={showPw ? 'text' : 'password'}
                                            placeholder="Enter new password"
                                            value={password}
                                            onChange={e => { setPassword(e.target.value); clearError('password'); }}
                                        />
                                        <button
                                            type="button"
                                            className="ap-pw-toggle"
                                            onClick={() => setShowPw(v => !v)}
                                            aria-label="Toggle password"
                                        >
                                            {showPw ? (
                                                <svg viewBox="0 0 16 16" fill="none" width="15" height="15"><path d="M2 2L14 14" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/><path d="M6.5 6.7A2 2 0 0 0 9.3 9.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/><path d="M4.3 4.5C3 5.3 2 6.6 2 8c0 0 2.5 4 6 4a6 6 0 0 0 3.7-1.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/><path d="M10.5 5.5A5.9 5.9 0 0 1 14 8c0 0-2.5 4-6 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/></svg>
                                            ) : (
                                                <svg viewBox="0 0 16 16" fill="none" width="15" height="15"><ellipse cx="8" cy="8" rx="5.5" ry="3.5" stroke="currentColor" strokeWidth="1.4"/><circle cx="8" cy="8" r="1.5" fill="currentColor"/></svg>
                                            )}
                                        </button>
                                    </div>
                                    {errors.password && <span className="ap-error">{errors.password}</span>}
                                </div>

                                {/* Confirm password */}
                                <div className="ap-field">
                                    <label className="ap-label" htmlFor="rp-confirm">Confirm Password</label>
                                    <div className="ap-input-wrap">
                                        <FaLock className="ap-input-icon" style={{ width: 15, height: 15 }} />
                                        <input
                                            id="rp-confirm"
                                            className={`ap-input${errors.confirm ? ' ap-input--error' : ''}`}
                                            type={showConfirm ? 'text' : 'password'}
                                            placeholder="Re-enter new password"
                                            value={confirmPassword}
                                            onChange={e => { setConfirmPassword(e.target.value); clearError('confirm'); }}
                                            onKeyDown={e => e.key === 'Enter' && handleChange()}
                                        />
                                        <button
                                            type="button"
                                            className="ap-pw-toggle"
                                            onClick={() => setShowConfirm(v => !v)}
                                            aria-label="Toggle confirm password"
                                        >
                                            {showConfirm ? (
                                                <svg viewBox="0 0 16 16" fill="none" width="15" height="15"><path d="M2 2L14 14" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/><path d="M6.5 6.7A2 2 0 0 0 9.3 9.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/><path d="M4.3 4.5C3 5.3 2 6.6 2 8c0 0 2.5 4 6 4a6 6 0 0 0 3.7-1.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/><path d="M10.5 5.5A5.9 5.9 0 0 1 14 8c0 0-2.5 4-6 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/></svg>
                                            ) : (
                                                <svg viewBox="0 0 16 16" fill="none" width="15" height="15"><ellipse cx="8" cy="8" rx="5.5" ry="3.5" stroke="currentColor" strokeWidth="1.4"/><circle cx="8" cy="8" r="1.5" fill="currentColor"/></svg>
                                            )}
                                        </button>
                                    </div>
                                    {/* Live match indicator */}
                                    {confirmPassword && password && (
                                        <span className={confirmPassword === password ? 'ap-success-msg' : 'ap-error'}>
                                            {confirmPassword === password ? '✓ Passwords match' : 'Passwords do not match'}
                                        </span>
                                    )}
                                    {errors.confirm && !confirmPassword && <span className="ap-error">{errors.confirm}</span>}
                                </div>

                                {errors.submit && (
                                    <div className="ap-banner ap-banner--error" style={{ marginBottom: 16 }}>
                                        <svg viewBox="0 0 16 16" fill="none" width="15" height="15"><circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.4"/><path d="M8 5v4M8 11v.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>
                                        {errors.submit}
                                    </div>
                                )}

                                <button
                                    className="ap-btn-primary"
                                    onClick={handleChange}
                                    disabled={loading}
                                    style={{ marginTop: 8 }}
                                >
                                    {loading ? <span className="ap-spinner" /> : 'Confirm'}
                                </button>
                            </div>
                        </>
                    )}
                </div>

                {!done && (
                    <p className="ap-below-card">
                        <button className="ap-back-link" onClick={() => navigate(-1)}>
                            <svg viewBox="0 0 16 16" fill="none" width="13" height="13">
                                <path d="M10 4L6 8L10 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            Go back
                        </button>
                    </p>
                )}
            </div>
        </div>
    );
}
